<template>
    <div class="app">
        <div class="column_box">
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/hxsc_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">海鲜水产</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/jqrl_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">家禽肉类</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/ggsc_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">瓜果蔬菜</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/jktc_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">进口特产</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/mbls_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">面包零食</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/jsyl.jpg"
                    alt=""
                >
                <div class="column_itemtext">酒水饮料</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/gzjg.jpg"
                    alt=""
                >
                <div class="column_itemtext">瓜子坚果</div>
            </div>
            <div
                class="column_item"
                @click="productlist"
            >
                <img
                    src="../../assets/image/img/首页/gd_img.jpg"
                    alt=""
                >
                <div class="column_itemtext">更多</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        components: {},
        data()
        {
            return {
                information: [
                {
                    text: "[资讯] 买卖鲜蒜小赚百万 冷藏商赚两份钱..."
                },
                {
                    text: "[资讯]网上销售农产品最高可获50万元奖励"
                },
                {
                    text: "[资讯]买卖鲜蒜小赚百万 冷藏商赚两份钱"
                },
                {
                    text: "[资讯]菜价虐我三四月 我待蔬菜如初恋"
                },
                {
                    text: "[资讯] 天气转暖菜价向下"
                }, ],
                centlist: [
                    {
                        names: "瓜类"
                    },
                    {
                        names: "菜叶类"
                    },
                    {
                        names: "茄果类"
                    },
                    {
                        names: "葱蒜类"
                    },
                    {
                        names: "甘蓝类"
                    },
                    {
                        names: "薯芋类"
                    },
                    {
                        names: "水生类"
                    },
                    {
                        names: "豆类"
                    },
                    {
                        names: "菌菇类"
                    },

                ]
            }
        },
        methods:
        {
            productlist()
            {
                this.$router.push(
                {
                    path: "/productlist"
                } )
            }
        },
        computed:
        {

        }
    }
</script>

<style scoped="scoped">
    .column_itemtext {
        width: 18.125rem;
        height: 9.0625rem;
        line-height: 9.0625rem;
        color: #FFFFFF;
        font-size: 30px;
        font-weight: 400;
        /* background-color: rgba(0,0,0,0.5); */
    }

    .column_item>img {
        width: 18.125rem;
        height: 9.0625rem;
    }

    .column_itemtext {
        position: absolute;
        top: 0;
        left: 0;
    }

    .column_item {
        width: 18.125rem;
        height: 9.0625rem;
        text-align: center;
        margin-bottom: 1.25rem;
        box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.5);
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }

    .column_box {
        width: 75rem;
        margin: auto;
        height: auto;
        background-color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .column_cent {
        width: 75rem;
        height: 31.5625rem;
        display: flex;
        justify-content: space-between;
        margin-top: 2.5rem;
    }

    .column_centA {
        width: 52.3125rem;
        height: 25.875rem;
        background-image: url(../../assets/image/img/首页/banner.jpg);
    }

    .column_centB {
        width: 20.8125rem;
        height: 25.875rem;
    }

    .column_centBa {
        width: 20.8125rem;
        height: 19.8125rem;
        background: #F6F6F6;
    }

    .column_centB img {
        cursor: pointer;
    }

    .column_centBb {}

    .column_centAbanan {
        color: #FFFFFF;
        width: 16.625rem;
        height: 25.875rem;
        background: #020202;
        opacity: 0.6;
    }

    .column_centAbanan h4 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 50px;
        text-align: center;
    }

    .column_centAlis {}

    .column_centAlisA {
        width: 100%;
        height: 3.125rem;
        border-bottom: 1px solid rgba(231, 231, 231, 0.1);
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    }

    .column_centAlisA:hover {
        background-color: #4E4F4D;
    }

    .column_centAl {
        display: flex;
    }

    .column_centAlisimgA {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -4px -92px;
        width: 17px;
        height: 19px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgB {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -30px -91px;
        width: 17px;
        height: 20px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgC {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -54px -95px;
        width: 22px;
        height: 14px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgD {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -81px -92px;
        width: 19px;
        height: 19px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgE {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -109px -94px;
        width: 18px;
        height: 16px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgF {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -109px -94px;
        width: 18px;
        height: 16px;
        margin: 1rem 0.9rem;
    }

    .column_centAlisimgs {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -348px -97px;
        width: 8px;
        height: 13px;
        margin: 1.2rem 1rem;
    }

    .column_centAl p {
        line-height: 3rem;
    }

    .column_centBatop {
        width: 100%;
        height: 3.75rem;
        border-bottom: 1px solid #E7E7E7;
        display: flex;
        justify-content: space-between;
    }

    .column_centBatopbox {
        display: flex;
    }

    .column_centBaimgsA {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -64px -5px;
        width: 18px;
        height: 14px;
        margin: 1.5rem 1rem;
    }

    .column_centBatopbox h4 {
        width: 10rem;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
        margin: 0.8rem 0rem;
    }

    .column_centBaimgsB {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -373px -92px;
        width: 49px;
        height: 20px;
        margin: 1.5rem 2rem;
        cursor: pointer;
    }

    .column_centBacentr {
        padding: 0rem 2rem;
    }

    .column_centBacentr li {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
        cursor: pointer;
        margin-top: 0.8rem;
    }

    .column_list {
        width: 34.9375rem;
        height: 24.5625rem;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        position: relative;
        margin: -22rem 17rem;
    }

    .column_lists {
        width: 19.0625rem;
        height: 100%;
    }

    .column_centlist {
        width: 100%;
        display: flex;

    }

    .column_centlistA {
        width: 5rem;
        height: 1.625rem;
        background: #069338;
        border-radius: 13px;
    }

    .column_centlistA p {
        width: 28px;
        height: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 34px;

    }
</style>